const FormResources = {

    form_data:{
        type: '',
        building_id: '',
        level_id: '',
        area_id: '',
        task_id: '',
        frequency_manual: '',
        frequency_id: '',
        description: '',
    },

    form_format:[
        {
            css_class:  'col-md-6 forecaster__select__item',
            type:       'select',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Task:',
            model_name: 'task_id',
            ref:        'task_id_input',
            ref_alt:    'task_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6 forecaster__select__item',
            type:       'number',
            maxlength:  65,
            minlength:  0,
            disabled:   true,
            step:       '',
            name:       'Frequency:',
            model_name: 'frequency_manual',
            ref:        'frequency_manual_input',
            ref_alt:    'frequency_manual_input_alt',
            required:   false,
        },
    ],

    form_format_project:[
        {
            css_class:  'col-md-6 forecaster__select__item',
            type:       'select',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Task:',
            model_name: 'task_id',
            ref:        'task_id_input',
            ref_alt:    'task_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6 forecaster__select__item',
            type:       'select',
            maxlength:  '',
            disabled:   true,
            step:       '',
            name:       'Frequency:',
            model_name: 'frequency_id',
            ref:        'frequency_id_input',
            ref_alt:    'frequency_id_input_alt',
            required:   false,
        },
    ],

    room_form_format:[
        {
            css_class:  'col-md-3 forecaster__select__item',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Building:',
            model_name: 'building_id',
            ref:        'building_id_input',
            ref_alt:    'building_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3 forecaster__select__item',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Level:',
            model_name: 'level_id',
            ref:        'level_id_input',
            ref_alt:    'level_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3 forecaster__select__item',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Area:',
            model_name: 'area_id',
            ref:        'area_id_input',
            ref_alt:    'area_id_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3 forecaster__select__item',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        // {
        //     css_class:  'col-md-3 forecaster__select__item',
        //     type:       'select',
        //     maxlength:  '',
        //     disabled:   false,
        //     step:       '',
        //     name:       'Task:',
        //     model_name: 'task_id',
        //     ref:        'task_id_input',
        //     ref_alt:    'task_id_input_alt',
        //     required:   true,
        // },
    ],

    radio_options:[
        {
            div_class:      'col-md-3 p-0 form-check custom-radio',
            input_class:    'custom-control-input',
            label_class:    'form-check-label radiobutton__text custom-control-label',
            ref:            'daily',
            name:           'Daily',
            model:          'type',
        },
        {
            div_class:      'col-md-3 p-0 form-check custom-radio',
            input_class:    'custom-control-input',
            label_class:    'form-check-label radiobutton__text custom-control-label',
            ref:            'project',
            name:           'Project',
            model:          'type',
        },
        {
            div_class:      'col-md-3 p-0 form-check custom-radio',
            input_class:    'custom-control-input',
            label_class:    'form-check-label radiobutton__text custom-control-label',
            ref:            'policing',
            name:           'Policing',
            model:          'type',
        },
        // {
        //     div_class:      'col-md-3 p-0 form-check custom-radio',
        //     input_class:    'custom-control-input',
        //     label_class:    'form-check-label radiobutton__text custom-control-label',
        //     ref:            'all',
        //     name:           'All',
        //     model:          'type',
        // },
    ],
}

export default FormResources;